
import AutomationAPIService from '@/modules/automations/services/apiService'

export default class AutomationModule {
  constructor() {
  }

  install(Vue) {
    // Services
    Vue.prototype.$apiService.automationService = new AutomationAPIService(Vue.prototype.$api, Vue.prototype.$reportingApi)
  }

  getRoutes() {
    return [
      {
        path: '/automations/rules',
        name: 'Automations List',
        component: () => import('@/modules/automations/views/automationRuleList.vue'),
        meta: {
          requiresAuth: true,
          title: 'Automation Rule List',
          menuLink: '/automations/rules',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/automations/rules/new',
        name: 'NewAutomationRule',
        component: () => import('@/modules/automations/views/automationRuleNew.vue'),
        meta: {
          requiresAuth: true,
          title: 'New Automation Rule',
          menuLink: '/automations/rules',
          breadcrumbs: [
              { title: 'Home', link: '/'},
          ],
        }
      },
      {
        path: '/automations/rules/:id(\\d+)',
        name: 'AutomationRule',
        component: () => import('@/modules/automations/views/automationRule.vue'),
        meta: {
          requiresAuth: true,
          title: 'Automation Rule',
          menuLink: '/automations/rules',
          breadcrumbs: [
              { title: 'Home', link: '/'},
              { title: 'Automation Rule List', link: '/automations/rules' }
          ],
        }
      }
    ]
  }
}
